import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {MdcFloatingLabelModule} from '@shraddhar/web/floating-label';
import {MdcLineRippleModule} from '@shraddhar/web/line-ripple';
import {MdcNotchedOutlineModule} from '@shraddhar/web/notched-outline';
import {MdcFormFieldModule} from '@shraddhar/web/form-field';
import {MdcMenuModule} from '@shraddhar/web/menu';
import {MdcListModule} from '@shraddhar/web/list';

import {MdcSelect} from './select';
import {MdcSelectIcon} from './select-icon';

const SELECT_DECLARATIONS = [
  MdcSelect,
  MdcSelectIcon,
];

@NgModule({
  imports: [
    CommonModule,
    MdcMenuModule,
    MdcListModule,
    MdcFormFieldModule,
    MdcFloatingLabelModule,
    MdcNotchedOutlineModule,
    MdcLineRippleModule
  ],
  exports: [
    MdcMenuModule,
    MdcListModule,
    MdcFormFieldModule,
    SELECT_DECLARATIONS
  ],
  declarations: SELECT_DECLARATIONS
})
export class MdcSelectModule {}
